export const REG_NRP = /^(50|20)(25|53|54)231\d{3}$/;

export const REG_EMAIL =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

export const REG_PASSWORD = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

export const REG_NIK =
  /^(1[1-9]|21|[37][1-6]|5[1-3]|6[1-5]|[89][12])\d{2}\d{2}([04][1-9]|[1256][0-9]|[37][01])(0[1-9]|1[0-2])\d{2}\d{4}$/;

export const REG_LINKEDIN =
  /^https:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?$/;

export const REG_INSTAGRAM =
  /^https:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9_.]+\/?$/;

export const REG_TIKTOK = /^https:\/\/(www\.)?tiktok\.com\/@[a-zA-Z0-9_.]+\/?$/;

export const REG_TWITTER = /^https:\/\/(www\.)?twitter\.com\/[a-zA-Z0-9_]+\/?$/;

export const REG_GDRIVE =
  /^https:\/\/drive\.google\.com\/drive\/folders\/[a-zA-Z0-9_-]+/;

export const REG_NAMA_TIM = /^[a-zA-Z0-9 ]{1,20}$/;
